import { Injectable } from "@angular/core";

export interface IRcLogger {
  info(message: string, arg1?: any, arg2?: any): void;
  debug(message: string, arg1?: any, arg2?: any): void;
  trace(message: string, arg1?: any, arg2?: any): void;
  warning(message: string, arg1?: any, arg2?: any): void;
  error(message: string, arg1?: any, arg2?: any): void;
  saveToFile(): void;
  clearCurrentLogs(): void;
}

export interface ILoggerConfiguration {
  setLogLevel(level: 'Error' | 'Warning' | 'Info' | 'Debug' | 'Trace'): void;
  lineLimit(limit: number): number;
  recording(flag: boolean): boolean;
}

@Injectable({
  providedIn: "root"
})
export class RcLoggerService implements IRcLogger, ILoggerConfiguration {
  private internalLogger: any = console;
  private errorLogEnabled: boolean = true;
  private warningLogEnabled: boolean = false;
  private infoLogEnabled: boolean = false;
  private debugLogEnabled: boolean = false;
  private traceLogEnabled: boolean = false;

  public get isDebugLogEnabled(): boolean {
    return this.debugLogEnabled;
  }

  public setLogger(loggingApi: any) {
    this.internalLogger = loggingApi;
  }

  private writeLog(prefix: string, originalArguments: IArguments): void {
    if (originalArguments.length > 0) {
      const args = Array.prototype.slice.call(originalArguments, 0);
      let rawArgs: any[] = [];

      if (typeof args[0] === 'string') {
        let message: string = args[0];
        args.splice(0, 1);

        for (let i = 0; i < args.length; i++) {
          if (
            typeof args[i] !== 'string' &&
            typeof args[i] !== 'number' &&
            !(args[i] instanceof Date)
          ) {
            args[i] = JSON.stringify(args[i]);
          }
        }

        message = message.toString();
        const time = new Date();
        const timestring =
          time.getHours().toString().padStart(2, '0') +
          ':' +
          time.getMinutes().toString().padStart(2, '0') +
          ':' +
          time.getSeconds().toString().padStart(2, '0') +
          '.' +
          time.getMilliseconds().toString().padStart(3, '0');
        this.internalLogger.log('[' + timestring + ']' + prefix + ' ' + message);
      } else {
        rawArgs = args;
      }

      for (let i = 0; i < rawArgs.length; i++) {
        console.log(rawArgs[i]);
      }
    }
  }

  public info(message: string, arg1?: any, arg2?: any): void {
    if (this.infoLogEnabled) {
      this.writeLog('[I]', arguments);
    }
  }

  public debug(message: string, arg1?: any, arg2?: any): void {
    if (this.debugLogEnabled) {
      this.writeLog('[D]', arguments);
    }
  }

  public trace(message: string, arg1?: any, arg2?: any): void {
    if (this.traceLogEnabled) {
      this.writeLog('[T]', arguments);
    }
  }

  public warning(message: string, arg1?: any, arg2?: any): void {
    if (this.warningLogEnabled) {
      this.writeLog('[W]', arguments);
    }
  }

  public error(message: string, arg1?: any, arg2?: any): void {
    if (this.errorLogEnabled) {
      this.writeLog('[E]', arguments);
    }
  }

  public saveToFile(): void {
    this.internalLogger.downloadLog();
  }

  public clearCurrentLogs(): void {
    this.internalLogger.clear();
  }

  public setLogLevel(level: 'Error' | 'Warning' | 'Info' | 'Debug' | 'Trace'): void {
    let errorFlag = true;
    let warningFlag = false;
    let infoFlag = false;
    let debugFlag = false;
    let traceFlag = false;

    switch (level) {
      case 'Error':
        warningFlag = false;
        infoFlag = false;
        debugFlag = false;
        traceFlag = false;
        break;
      case 'Warning':
        warningFlag = true;
        infoFlag = false;
        debugFlag = false;
        traceFlag = false;
        break;
      case 'Info':
        warningFlag = true;
        infoFlag = true;
        debugFlag = false;
        traceFlag = false;
        break;
      case 'Debug':
        warningFlag = true;
        infoFlag = true
        debugFlag = true;
        traceFlag = false;
        break;
      case 'Trace':
        warningFlag = true;
        infoFlag = true;
        debugFlag = true;
        traceFlag = true;
        break;
    }

    // this.toggleLevels(errorFlag, warningFlag, infoFlag, debugFlag, traceFlag);
    this.errorLogEnabled = errorFlag;
    this.warningLogEnabled = warningFlag;
    this.infoLogEnabled = infoFlag;
    this.debugLogEnabled = debugFlag;
    this.traceLogEnabled = traceFlag;
  }

  //  toggleLevels: (error: boolean, warning: boolean, info: boolean, debug: boolean, trace: boolean): void => {
  //   this.errorLogEnabled = error;
  //   this.warningLogEnabled = warning;
  //   this.infoLogEnabled = info;
  //   this.debugLogEnabled = debug;
  //   this.traceLogEnabled = trace;
  // },

  public lineLimit(limit: number): number {
    if (typeof limit === 'number') {
      this.internalLogger.maxLines = limit;
    }

    return this.internalLogger.maxLines;
  }

  public recording(flag: boolean): boolean {
    if (typeof flag === 'boolean') {
      this.internalLogger.recordLogs = flag;
    }

    return this.internalLogger.recordLogs;
  }
}
